import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import logo from "../../assets/aas_logo_small.svg";
import {fontType} from "../../constants/font";

const Vision = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });
  const [products, inViewProducts] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });

  return (
    <Box
      sx={{
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        paddingBottom: "154px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          maxWidth: "1440px",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
          marginTop: { sm: "99px", xs: "70px" },
        }}
      >
        <img style={{ width: "162px" }} src={logo} alt="aas_logo_small" />
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.7 }}
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <Typography
            sx={{
              fontFamily: fontType.regular,
              fontSize: 38,
              color: "#1b144a",
              textAlign: "center",
              marginTop: "60px",
              zIndex: 2,
            }}
          >
            NAŠE CIELE A VÍZIA
          </Typography>
          <Typography
            sx={{
              fontFamily: fontType.regular,
              fontSize: 22,
              lineHeight: "28px",
              color: "#1b144a",
              textAlign: "center",
              maxWidth: "702px",
              width: "100%",
              marginTop: "4px",
              zIndex: 2,
            }}
          >
              Sme tu, aby sme pomáhali ľuďom rásť v oblasti testovania a IT.<br />
              Našou víziou je <span style={{fontFamily: fontType.semiBold}}>spájať vzdelávanie s praxou</span> a prinášať moderné prístupy vrátane <span style={{fontFamily: fontType.semiBold}}>testovania s využitím GenAI</span>.<br />
              Pozeráme sa dopredu – pripravujeme našich študentov na <span style={{fontFamily: fontType.semiBold}}>testovanie budúcnosti</span>.
          </Typography>
        </motion.div>
        <motion.div
          ref={products}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.7 }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              // maxWidth: "1197px",
              marginTop: "85px",
              gap: "27px",
              paddingLeft: { xs: "10px", sm: "0px" },
              paddingRight: { xs: "10px", sm: "0px" },
            }}
          >
            <Grid
              item
              sx={{
                backgroundColor: "#1b144a",
                height: "270px",
                maxWidth: "382px",
                width: { lg: "382px", xs: "100%" },
                borderRadius: "22px",
                transform: "scale(1)",
                transition: "transform 0.3s ease",
                "&:hover": {
                  // Styles on hover
                  transform: "scale(1.1)",
                },
              }}
            >
              <Box sx={{ paddingTop: "29px", paddingRight: "50px" }}>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 28,
                    lineHeight: "30px",
                    color: "#3fcaea",
                    marginLeft: "26px",
                    marginBottom: { sm: "21px", xs: "10px" },
                  }}
                >
                  Zmysel pre detail
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 18,
                    lineHeight: "22px",
                    color: "white",
                    marginLeft: "26px",
                  }}
                >
                    Detail rozhoduje.<br />
                    Naši lektori aj mentori sú profesionáli, ktorí <span style={{fontFamily: fontType.semiBold}}>vidia aj to, čo ostatní prehliadnu</span>.<br />
                    Učíme ťa, ako myslieť ako tester – presne, systematicky a s dôrazom na kvalitu.
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              sx={{
                backgroundColor: "#1b144a",
                height: "270px",
                maxWidth: "382px",
                width: { lg: "382px", xs: "100%" },
                borderRadius: "22px",
                transform: "scale(1)",
                transition: "transform 0.3s ease",
                "&:hover": {
                  // Styles on hover
                  transform: "scale(1.1)",
                },
              }}
            >
              <Box sx={{ paddingTop: "29px", paddingRight: "20px" }}>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 28,
                    lineHeight: "30px",
                    color: "#f6961d",
                    marginLeft: "26px",
                    marginBottom: { sm: "21px", xs: "10px" },
                  }}
                >
                    Rastieme spolu
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 18,
                    lineHeight: "22px",
                    color: "white",
                    marginLeft: "26px",
                  }}
                >
                    Veríme v <span style={{fontFamily: fontType.semiBold}}>neustály rozvoj</span> – našich študentov aj nás samotných.<br />
                    Sledujeme najnovšie trendy, technológie a prinášame ich priamo do výučby.<br />
                    Tak sa z tvojho prvého testu môže stať <span style={{fontFamily: fontType.semiBold}}>tvoja prvá kariéra v IT</span>.
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              sx={{
                backgroundColor: "#1b144a",
                height: "270px",
                maxWidth: "382px",
                width: { lg: "382px", xs: "100%" },
                borderRadius: "22px",
                transform: "scale(1)",
                transition: "transform 0.3s ease",
                "&:hover": {
                  // Styles on hover
                  transform: "scale(1.1)",
                },
              }}
            >
              <Box sx={{ paddingTop: "29px", paddingRight: "10px" }}>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 28,
                    lineHeight: "30px",
                    color: "#7b7cd5",
                    marginLeft: "26px",
                    marginBottom: { sm: "21px", xs: "10px" },
                  }}
                >
                    Naše zázemie
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fontType.regular,
                    fontSize: 18,
                    lineHeight: "22px",
                    color: "white",
                    marginLeft: "26px",
                  }}
                >
                    Od roku 2013 budujeme <span style={{fontFamily: fontType.semiBold}}>silný tím odborníkov</span>, ktorí spájajú prax, know-how a moderné prístupy vo vzdelávaní.<br />
                    Naše skúsenosti stoja na reálnych projektoch, vďaka čomu dokážeme <span style={{fontFamily: fontType.semiBold}}>študentov pripraviť na skutočný svet testovania</span>.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </motion.div>
      </Box>
    </Box>
  );
};

export default Vision;
